export const initNewsletterForms = () => {
	const newsletterInputs = document.querySelectorAll('.js-newsletter-input');

	newsletterInputs.forEach((input) => {
		input.addEventListener('input', (event) => {
			const value = event.target.value;
			const parentForm = input.closest(".js-newsletter-form");
			const originalFormUrl = parentForm.dataset.originalAction;

			if (value) {
				parentForm.action = `${originalFormUrl}&email=${value}`;
			} else {
				parentForm.action = originalFormUrl;
			}
  		});
	});
};
